export const InstallationEventStatus = {
    InstallationStarted: "INSTALLATION_STARTED",
    backupUploadStarted: "BACKUP_UPLOAD_STARTED",
    backupUploadSucceeded: "BACKUP_UPLOAD_SUCCEEDED",
    backupUploadFailed: "BACKUP_UPLOAD_FAILED",
    compressionStarted: "COMPRESSION_STARTED",
    compressionFailed: "COMPRESSION_FAILED",
    compressionSucceeded: "COMPRESSION_SUCCEEDED",
    localMigrationStarted: "LOCAL_MIGRATION_STARTED",
    localMigrationSucceeded: "LOCAL_MIGRATION_SUCCEEDED",
    localMigrationFailed: "LOCAL_MIGRATION_FAILED",
    onPremise: "ON_PREMISE",
    provisioningRestarted: "PROVISIONING_RESTARTED",
    provisioningStarted: "PROVISIONING_STARTED",
    provisioningSucceeded: "PROVISIONING_SUCCEEDED",
    provisioningFailed: "PROVISIONING_FAILED",
    provisioningRunning: "PROVISIONING_RUNNING",
    confirmationEmailSent: "CONFIRMATION_EMAIL_SENT",
    pendingDelete: "PENDING_DELETE",
    removesPendingDelete: "REMOVES_PENDING_DELETE",
    uninstallationStarted: "UNINSTALLATION_STARTED",
    uninstallationRunning: "UNINSTALLATION_RUNNING",
    failedToStartUninstall: "FAILED_TO_START_UNINSTALL",
    uninstallationFailed: "UNINSTALLATION_FAILED",
    uninstallationSucceeded: "UNINSTALLATION_SUCCEEDED",
    UpdateStarted: "UPDATE_STARTED",
    FailedToStartUpdate: "FAILED_TO_START_UPDATE",
    UpdateFailed: "UPDATE_FAILED",
    UpdateSucceeded: "UPDATE_SUCCEEDED",
    RetentionUninstallStarted: "RETENTION_UNINSTALL_STARTED",
    RetentionUninstallSucceeded: "RETENTION_UNINSTALL_SUCCEEDED",
    RetentionUninstallFailed: "RETENTION_UNINSTALL_FAILED",
    RetentionStarted: "RETENTION_STARTED",
    RetentionSucceeded: "RETENTION_SUCCEEDED",
    RetentionFailed: "RETENTION_FAILED"
};

export const InstallationsGroupStatuses = {
    allInstallations: "ALL_INSTALLATIONS",
    inProgressAndCompletedInstallations:
        "IN_PROGRESS_AND_COMPLETED_INSTALLATIONS",
    inProgressInstallations: "IN_PROGRESS_INSTALLATIONS",
    completedInstallations: "COMPLETED_INSTALLATIONS",
    failedInstallations: "FAILED_INSTALLATIONS",
    pendingDelete: "PENDING_DELETE"
};

export const TicketEventStatus = {
    ticketToDo: "TO_DO",
    ticketInProgress: "IN_PROGRESS",
    ticketDone: "DONE",
    all: "TO_DO,IN_PROGRESS,DONE",
    ticketTobeAssignedOrInPRogress: "IN_PROGRESS,TO_DO"
};

export const eventStatusColorMap = {
    [TicketEventStatus.ticketToDo]: "#ff9800",
    [TicketEventStatus.ticketInProgress]: "#2db7f5",
    [TicketEventStatus.ticketDone]: "#87d068"
};

export const OperationType = {
    Installation: "INSTALLATION",
    Migration: "MIGRATION",
    UrlTransfer: "URL_TRANSFER",
    CompanyTransfer: "COMPANY_TRANSFER",
    CustomerTransfer: "CUSTOMER_TRANSFER",
    Delete: "DELETE",
    ForceDelete: "FORCE_DELETE",
    Retention: "RETENTION",
    RetentionUninstall: "RETENTION_UNINSTALL",
    GetInstallationInfo: "GET_INSTALLATION_INFO",
    SanitizeDB: "SANITIZE_DB"
};



// WEBPACK FOOTER //
// ./src/common/statuses.js